// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DatasetVersionRead } from "./DatasetVersionRead";
import {
  DatasetVersionReadFromJSON,
  DatasetVersionReadFromJSONTyped,
  DatasetVersionReadToJSON,
  DatasetVersionReadToJSONTyped,
} from "./DatasetVersionRead";

/**
 *
 * @export
 * @interface PageDatasetVersionRead
 */
export interface PageDatasetVersionRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<DatasetVersionRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageDatasetVersionRead interface.
 */
export function instanceOfPageDatasetVersionRead(value: object): value is PageDatasetVersionRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageDatasetVersionReadFromJSON(json: any): PageDatasetVersionRead {
  return PageDatasetVersionReadFromJSONTyped(json, false);
}

export function PageDatasetVersionReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageDatasetVersionRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(DatasetVersionReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageDatasetVersionReadToJSON(json: any): PageDatasetVersionRead {
  return PageDatasetVersionReadToJSONTyped(json, false);
}

export function PageDatasetVersionReadToJSONTyped(
  value?: PageDatasetVersionRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(DatasetVersionReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
